import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyTransporter = ({
    value,
    handleChange,
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: 'vendorMaster/vendors' })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])

    const handleSearch = (e, data) => {
        setloading(true)
        let searchTerm = data.searchQuery
        ReadAxios({ url: 'vendorMaster/vendors', readItems: { searchTerm: searchTerm } })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }
    let options = []
    if (content?.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = index
            temp.text = `${object.transporterName} (${object.transporterCode})`
            temp.value = props.idValue ? object.vendorId :{ vendorId: object.vendorId, code: object.transporterCode, transporterName: object.transporterName }
            return options[index] = temp
        })
    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            clearable
            onSearchChange={handleSearch}
            value={value}
        />
    )
}

export default MyTransporter